<button
  id="visualizeImageButton"
  class="accent transparent"
  mat-flat-button
  [class.waiting]="waiting"
  appStopPropagation
  (click)="visualizeImage()">
  <ng-container *ngIf="!waiting"> {{ 'button.visualizeImage' | translate }} </ng-container>

  <mat-spinner *ngIf="waiting" [diameter]="20"></mat-spinner>
</button>
